import { observer } from "mobx-react";
import * as React from "react";
import { useShouldShowDarkMode } from "../api/settings/useShouldShowDarkMode";
import { CvpButton } from "../generic-components/buttons/CvpButton";
import { useLocStore } from "../localization";
import { LocContext } from "../localization/LocContext";

export const DarkModeToggleButton = observer(() => {
  const { darkMode, setDarkModeUserPreference } = useShouldShowDarkMode();

  const L = useLocStore(LocContext.GENERAL);

  return (
    <CvpButton
      icon={darkMode ? "pi pi-moon" : "pi pi-sun"}
      title={L.id("cc2f06c600cb").loc("Bytt fargetema")}
      rounded
      text
      onClick={() => {
        setDarkModeUserPreference(!darkMode);
      }}
      style={{
        width: "2rem",
        height: "2rem",
        padding: 0,
      }}
    />
  );
});
